var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DialogInput"},[_c('p',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('DialogBaseInput',{attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"error":_vm.error,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42a2ac39","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./yotta-vue-components/vision/DialogInput.vue
// module id = null
// module chunks = 